import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";
import {loaderDisable, loaderEnable} from "./loaderView";
import {getNavigationButtons} from "../../api/server-api";
import NoInternetIcon from "./icons/noInternetIcon";

const NoInternetOverlay = (props) => {

  // const {networkConnection, showAdvancedQuoting, isMobile} = props;
  const {networkConnection, showFilters} = props;

  if (networkConnection) { // show only if internet is offline
    return null
  }

  const retryConnectionClick = async () => {
    loaderEnable();
    await getNavigationButtons(true);
    loaderDisable();
  }

  return (
    // <div className={"dcart-overlay" + (isMobile && showAdvancedQuoting ? " dcart-overlay--footer" : "")}>
    <div className={"dcart-overlay" + (showFilters ? " dcart-overlay--filters-active" : "")}>
      <div className="dcart-overlay__icon">
        <NoInternetIcon/>
      </div>
      <div className="dcart-overlay__title">
        <FormattedMessage id="networkConnection.title"/>
      </div>
      <div className="dcart-overlay__text">
        <FormattedMessage id="networkConnection.text"/>
      </div>
      <div className="dcart-overlay__button">
        <button className="ui-button2 ui-button2--green" onClick={() => retryConnectionClick()}>
          <FormattedMessage id="networkConnection.button"/>
        </button>
      </div>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {networkConnection, isMobile} = store.serverState;
  const {showAdvancedQuoting} = store.advancedQuotingState;
  const {showFilters} = store.filterState;

  return {
    networkConnection,
    isMobile,
    showAdvancedQuoting,
    showFilters,
  };
};

export default connect(mapStateToProps)(NoInternetOverlay)
